<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="form.name"
              class="w-full"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium">Описание</label>
            <crm-editor [(value)]="form.description"></crm-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Цена за пользователя</label>
            <p-inputNumber
              [(ngModel)]="form.price"
              class="w-full {{ errors?.price ? 'ng-invalid ng-dirty' : '' }}"
              styleClass="w-full {{ errors?.price ? 'ng-invalid ng-dirty' : '' }}"
              [min]="0"></p-inputNumber>
            <small
              *ngIf="errors?.price"
              class="p-error">
              {{ errors.price | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Модули</label>
            <crm-multi-select
              [options]="modules"
              [(selectedItems)]="selectedModules"
              (selectedItemsChange)="changeModules($event)"
              [class]="errors?.availableModules ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.availableModules ? 'ng-invalid ng-dirty' : ''"
              dataKey="systemName"
              sort="displayName:string"
              optionLabel="displayName"
              filterBy="displayName"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-option="item">
                <div>
                  <p>{{ option?.displayName }}</p>
                  <small class="text-gray-400">{{ option?.description }}</small>
                </div>
              </ng-template>
            </crm-multi-select>
            <small
              *ngIf="errors?.availableModules"
              class="p-error">
              {{ errors.availableModules | join }}
            </small>
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [(ngModel)]="form.isDefault"
              [binary]="true"
              inputId="isDefault"></p-checkbox>
            <label [for]="'isDefault'">По умолчанию</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="col-12 flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveItem()"></button>
      <button
        *ngIf="(form$ | async)?.isEdit"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteRatePlan()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
